import { memo } from 'react';
import { Autocomplete, AutocompleteItem } from '@heroui/react';

const AutoComplete = memo(function AutoComplete({
  title,
  name,
  data,
  placeholder,
  required,
  value,
  errors,
  touched,
  setFieldValue,
}) {
  return (
    <div className="flex flex-col items-start justify-end gap-2.5 w-full relative">
      <div className="flex flex-row items-center gap-1 w-full h-6">
        <p className="titleInput">{title}</p>
      </div>
      <div className="flex w-full flex-wrap md:flex-nowrap gap-4 h-[48px]">
        <Autocomplete
          showScrollIndicators={true}
          defaultSelectedKey={value}
          value={value}
          name={name}
          onSelectionChange={(e) => setFieldValue(name, e)}
          inputProps={{
            classNames: {
              mainWrapper:
                'group-data-[hover=true]:bg-white dark:group-data-[hover=true]:bg-blackFont-800 group-data-[focus=true]:bg-white dark:group-data-[focus=true]:bg-blackFont-800',
              input:
                'group-data-[hover=true]:bg-white dark:group-data-[hover=true]:bg-blackFont-800 group-data-[focus=true]:bg-white dark:group-data-[focus=true]:bg-blackFont-800 text-text-hard dark:text-white',
              inputWrapper: `h-[48px] bg-white dark:bg-blackFont-800 shadow-none ${
                errors && touched ? 'border-error' : 'border-light-grey dark:border-blackFont-700'
              } border-1 rounded-lg group-data-[hover=true]:bg-white dark:group-data-[hover=true]:bg-blackFont-800 group-data-[focus=true]:bg-white dark:group-data-[focus=true]:bg-blackFont-800 transition-all`,
            },
          }}
          classNames={{
            value: [
              'text-base',
              'text-text-normal/70',
              'dark:text-white/70',
              'font-light',
              'group-data-[has-value=true]:text-text-hard',
              'dark:group-data-[has-value=true]:text-white',
              'group-data-[has-value=true]:font-normal',
            ],
            popoverContent:
              'p-0 rounded-lg border-1 border-light-grey dark:border-blackFont-700 dark:bg-blackFont-800',
            listbox: 'p-2 dark:bg-blackFont-800',
            listboxWrapper: 'p-1',
          }}
          className="custom-select"
          listboxProps={{
            emptyContent: 'موردی یافت نشد',
            style: {
              overflowY: 'scroll',
              maxHeight: '250px',
            },
            itemClasses: {
              base: [
                'data-[hover=true]:bg-gray',
                'dark:data-[hover=true]:bg-blackFont-700',
                'data-[selectable=true]:focus:bg-gray',
                'dark:data-[selectable=true]:focus:bg-blackFont-700',
                'data-[selected=true]:text-primary',
                'data-[selected=true]:focus:text-primary',
                'data-[pressed=true]:opacity-100',
                'data-[focus=true]:bg-secondary',
                'dark:data-[focus=true]:bg-blackFont-700',
              ],
            },
          }}
          placeholder={placeholder}
        >
          {name == 'province' ? (
            data.map((item) => (
              <AutocompleteItem key={item.province} textValue={item.province}>
                <div className="flex flex-col items-start p-1">
                  <p className="text-base dark:text-white">{item.province}</p>
                </div>
              </AutocompleteItem>
            ))
          ) : !data ? (
            <AutocompleteItem>
              <div className="flex flex-col items-start p-1">
                <p className="text-base dark:text-white">استان خود را انتخاب کنید</p>
              </div>
            </AutocompleteItem>
          ) : (
            data.map((item) => (
              <AutocompleteItem key={item} textValue={item}>
                <div className="flex flex-col items-start p-1">
                  <p className="text-base dark:text-white">{item}</p>
                </div>
              </AutocompleteItem>
            ))
          )}
        </Autocomplete>
      </div>
      {errors && touched && <p className="absolute -bottom-6 text-xs text-error">{errors}</p>}
    </div>
  );
});

export default AutoComplete;
